import CustomView from "./custom-view";
import PermissionsCustomView from "../../gd/access-control/permissions/custom-view";
import {PERSONAL_VIEW_TYPES, ViewType} from "../../gd/const/views/view-type";
import customViewFactory from "./factory";
import {NavigationSectionType} from "../navigation/@const";
import Collection from "../../data-structures/collection";
import ViewMyAttendance from "./views/my-attendance"
import {MY_WORK_VIEWS} from "../../gd/const/views/view-type-config"
import moduleClockInOut_initCustomView from "../../modules/clock-in-out/actions/init-custom-view"

const debug = {
    dev: false,
    head: 'CustomViewsSessionCollection'
}

export default class CustomViewsSessionCollection extends Collection<CustomView> {

    constructor(models = []) {
        super(models)
    }

    resetFromData(data:any) {

        debug.dev && console.log(debug.head, ".resetFromData", data);

        this.models    = []
        this.byId      = {}

        _.map(data, (customViewData)=>{

            const view = customViewFactory(customViewData)

            if (view) {
                this.add(view)
            } else {
                console.log("#93847 - ignore custom view view")
            }

        })

        moduleClockInOut_initCustomView()

        gd?.bus?.triggerEvent('gd.session.customViews:change');
    }

    reset(views:CustomView[]) {

        debug.dev && console.log(debug.head, ".reset", views);

        this.models    = []
        this.byId      = {}

        _.map(views, model=>{
            this.add(model)
        })
        gd?.bus?.triggerEvent('gd.session.customViews:change');

    }

    add(model:CustomView) {

        // some views we created before could be denied now
        const availableViews = PermissionsCustomView.getAllAvailable();

        if (!availableViews.includes(model.type)) {
            debug.dev && console.log(debug.head, "#jdhdsuw9 cant add this view", model, "is not in available views")
            return
        }

        this.models.push(model)
        this.byId[model.id] = model
    }

    updateDynamicViews() {
        /**---- CLOCK IN/OUT [Start] ----**/
        const isAttendanceViewRequired  = gd.modules.clockInOut.enabled && gd.session.companyUsers.getByUserId(gd.user.id)?.clockInOutEnabled
        const attendanceView            = this.getByViewType(ViewType.MY_ATTENDANCE)[0] as ViewMyAttendance

        //if attendance view is required and no attendance view them add dynamic one
        if (isAttendanceViewRequired && !attendanceView) {
            const view = new ViewMyAttendance()
            this.add(view)
            view.addNavigationSortPosition()
        }

        //if attendance view is NOT required but dynamic attendance view is added then remove it
        if (!isAttendanceViewRequired && attendanceView?.isDynamic) {
            attendanceView.removeFromNavigationSortPosition()
            this.remove(attendanceView.id)

        }
        /**---- CLOCK IN/OUT [End] ----**/
    }

    getFirstByType(type: ViewType):CustomView {

        return _.find(this.models,(customView:CustomView)=>{
            return customView.type === type
        }) as CustomView

    }

    getForNavigationPanel():CustomView[] {
        // hide projects list & workload views
        const views = _.filter(this.models, (view)=>{

            // We need ignore personal custom views as they are deprecated
            if (PERSONAL_VIEW_TYPES.includes(view.type)) {
                return false
            }

            return view.location===NavigationSectionType.NAVIGATION_PANEL
                    || view.location===NavigationSectionType.MORE

        });

        return views;
    }

    // getForNavigationMore():CustomView[] {
    //     // hide projects list & workload views
    //     const views = _.filter(this.models, (view)=>{
    //         return view.location===NavigationSectionType.MORE
    //     });
    //
    //     return views;
    // }

    getForTools() {
        // hide projects list & workload views
        const views = _.filter(this.models, (view)=>{
            // return ![ViewType.PROJECTS_PORTFOLIO, ViewType.PROJECTS_PROJECTS_LIST].includes(view.type) && !view.isSharedWithMe;
            return view.location==='tools' && !view.isSharedWithMe && view.type!==ViewType.CUSTOM_VIEW_DASHBOARD;
        });

        return views;
    }

    getForProjects() {
        // hide projects list & workload views
        const views = _.filter(this.models, (view)=>{
            return [ViewType.PROJECTS_PORTFOLIO, ViewType.PROJECTS_PROJECTS_LIST].includes(view.type);
        });

        return views;
    }

    getSharedWithMe() {
        const views = _.filter(this.models, (view)=>{
            return view.isSharedWithMe===true
        });

        return views;
    }

    getHomeMyViews():CustomView[] {
        return _.filter(this.models, (view)=>{

            if (view.location!==NavigationSectionType.HOME && view.location!==NavigationSectionType.HOME_MENU) return

            // no let's get ONLY my_XXX views
            return MY_WORK_VIEWS.includes(view.type)
            //
            //
            // if (view.type===ViewType.CUSTOM_VIEW_DASHBOARD) return false
            //
            // return view.location===NavigationSectionType.HOME || view.location===NavigationSectionType.HOME_MENU
        }) as CustomView[];
    }

    getProjectsViews():CustomView[] {
        return _.filter(this.models, (view)=>{
            return view.location===NavigationSectionType.PROJECTS
        }) as CustomView[]
    }

    getHomeCustomViews():CustomView[] {
        const views = _.filter(this.models, (view:CustomView)=>{

            if (view.location!==NavigationSectionType.HOME && view.location!==NavigationSectionType.HOME_MENU) return
            // if (view.location!==NavigationSectionType.HOME && view.location!==NavigationSectionType.HOME_MENU) return

            return !MY_WORK_VIEWS.includes(view.type)
            // return view.type === ViewType.CUSTOM_VIEW_DASHBOARD;
        }) as CustomView[];

        return views
    }

    getForMyWork() {
        return _.filter(this.models, (view)=>{

            if (view.type===ViewType.CUSTOM_VIEW_DASHBOARD) return false

            return view.location===NavigationSectionType.HOME || view.location===NavigationSectionType.HOME_MENU
        });
    }

    getForDashboards() {
        return _.filter(this.models, (view)=>{
            return view.type === ViewType.CUSTOM_VIEW_DASHBOARD;
        });
    }

    getForTeamsWidget() {
        // used in MS TEAMS integrations
        const views = _.filter(this.models, (view:CustomView)=>{
            return view.location==='tools';
        });

        return views;
    }

    getByViewType(type: ViewType) {
        return _.filter(this.models, (view)=>{
            return view.type === type
        })
    }

    // all():CustomView[] {
    //     const allViews : CustomView[] = this._views.all;
    //
    //     // some views we created before could be denied now
    //     const availableViews = PermissionsCustomView.getAllAvailable();
    //
    //     return _.filter(allViews, (view:CustomView)=>{
    //         return (availableViews.includes(view.type));
    //     }) as CustomView[]
    // }

    // get(viewId:ID) {
    //     return this.get(viewId);
    // }

    addOne(eventRaw:any) {
        this._add(eventRaw);
        gd.bus.triggerEvent('gd.session.customViews:change');
    }

    addMany(eventsRaw:any) {
        _.map(eventsRaw, eventRaw=>this._add(eventRaw));
        gd.bus.triggerEvent('gd.session.customViews:change');
    }

    _add(view:CustomView) {

        if (!view.type) {
            console.error("---- no view type #445593 -----")
            return false;
        }

        const viewModel = customViewFactory({
            id: view.id,
            type: view.type,
            name: view.name,
            params: view.params,
            userId: view.userId
        })

        if (viewModel) {
            this.add(viewModel);
        } else {
            //
        }


    }

    findExistingMyWorkViews() {

        // const existingMyWorkViews : CustomView[] = []; - seems wrong
        const existingMyWorkViews : any[] = []; // seems right
        _.map(this.models, view=>{
            if (MY_WORK_VIEWS.includes(view.type)) {
                existingMyWorkViews.push(view.type)
            }
        })
        return existingMyWorkViews;
    }

    remove(id:ID) {
        const removedView = super.remove(id)

        gd.bus.triggerEvent('gd.session.customViews:change');

        return removedView
    }

    update(view:any) {
        const viewModel = this.get(view.id)

        if (!viewModel) {
            // no view found
            return
        }

        viewModel.applyDelta(view)

        gd.bus.triggerEvent('gd.session.customViews:change', view)
    }

    debug() {
        console.log("gd.sesion.customViews:");
        console.log("    _views  : ", this.length);
    }

}
